import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const RefundsChart = ({ refunds }) => {
  // Group refunds by month
  const monthlyRefunds =
    refunds?.reduce((acc, r) => {
      const date = new Date(r.createdAt);
      const month = date.toLocaleString("default", { month: "short" });
      const year = date.getFullYear();
      const key = `${month} ${year}`;

      if (!acc[key]) acc[key] = 0;
      acc[key] += r.amount;
      return acc;
    }, {}) || {};

  // Convert to chart-friendly array
  const chartData = Object.entries(monthlyRefunds).map(([month, total]) => ({
    month,
    refunds: total,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis tickFormatter={(val) => `$${val}`} />
        <Tooltip formatter={(val) => [`$${val.toFixed(2)}`, "Refunds"]} />
        <Bar dataKey="refunds" fill="#dc3545" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RefundsChart;
